import { combineReducers } from 'redux'
import type { ChannelShareFormState } from './forms/channel-share'
import { channelShareFormReducer } from './forms/channel-share'
import type { LibraryClientsInviteState } from './forms/library-clients-invite'
import { libraryClientsInviteReducer } from './forms/library-clients-invite'
import type { State as ListFormState } from './forms/list'
import { listFormReducer } from './forms/list'
import type { ManageNestingFormState } from './forms/manage-nesting'
import { manageNestingFormReducer } from './forms/manage-nesting'
import type { PlaylistShareFormState } from './forms/playlistShare'
import { playlistShareFormReducer } from './forms/playlistShare'
import type { PricingFormState } from './forms/pricing'
import { pricingFormReducer } from './forms/pricing'
import type { State as ReferralInviteState } from './forms/referralInvite'
import { referralInviteReducer } from './forms/referralInvite'
import type { State as TrackMergeFormState } from './forms/trackMerge'
import { trackMergeReducer } from './forms/trackMerge'
export type FormsState = {
  playlistShareForm: PlaylistShareFormState
  referralInviteForm: ReferralInviteState
  trackMergeForm: TrackMergeFormState
  listForm: ListFormState
  channelShareForm: ChannelShareFormState
  libraryClientsInviteForm: LibraryClientsInviteState
  pricingForm: PricingFormState
  manageNesting: ManageNestingFormState
}
// reducer combines form related reducers
export const formsReducer = combineReducers({
  playlistShareForm: playlistShareFormReducer,
  referralInviteForm: referralInviteReducer,
  trackMergeForm: trackMergeReducer,
  listForm: listFormReducer,
  channelShareForm: channelShareFormReducer,
  libraryClientsInviteForm: libraryClientsInviteReducer,
  pricingForm: pricingFormReducer,
  manageNesting: manageNestingFormReducer,
})
